import Vue from "vue";
import Vuetify from "vuetify/lib";

const vuetifyOptions = {
  theme: {
    themes: {
      light: {
        primary: "#009688",
        secondary: "#607d8b",
        accent: "#00bcd4",
        error: "#f44336",
        warning: "#ffc107",
        info: "#03a9f4",
        success: "#4caf50",
      },
    },
  },
};
Vue.use(Vuetify);

export default new Vuetify(vuetifyOptions);
